import { Box, Skeleton, Tab, Tabs } from '@mui/material'
import React from 'react'

export default function PoolDetailsSkeleton(props: { includeTabs?: boolean }): React.ReactElement {
  const { includeTabs = false } = props

  return (
    <Box>
      {/* Main Content Skeleton */}
      <Box sx={{ width: '100%' }}>
        {/* Tabs Skeleton */}

        {includeTabs && (
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={0} variant="scrollable" scrollButtons="auto">
              <Tab label={<Skeleton width={100} />} />
              <Tab label={<Skeleton width={100} />} />
              <Tab label={<Skeleton width={100} />} />
              <Tab label={<Skeleton width={100} />} />
            </Tabs>
          </Box>
        )}

        {/* Content Skeleton */}
        <Box sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {/* Section Headers and Fields */}
            <Box>
              <Skeleton variant="text" width={200} height={32} sx={{ mb: 2 }} />
              <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 4 }}>
                {[...Array(6)].map((_, index) => (
                  <Box key={index} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Skeleton variant="text" width="60%" height={24} />
                    <Skeleton variant="text" width="40%" height={24} />
                  </Box>
                ))}
              </Box>
            </Box>

            {/* Another Section */}
            <Box>
              <Skeleton variant="text" width={200} height={32} sx={{ mb: 2 }} />
              <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 4 }}>
                {[...Array(4)].map((_, index) => (
                  <Box key={index} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Skeleton variant="text" width="60%" height={24} />
                    <Skeleton variant="text" width="40%" height={24} />
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
